import React from 'react';
import { Grid } from '@mui/material';

import { ModuleSearchField, SearchSelectField, SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function SkillsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={12}>
				{/* TITLE */}
				<SimpleTextField
					name="skll_title"
					label={t('DETAILS_SKILLS_FIELD_TITLE')}
					value={props.model.skll_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="skll_skty_id"
					label={t('DETAILS_SKILLS_FIELD_TYPE')}
					value={props.model.skll_skty_id}
					systable="skills_types"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* USER ASSIGNED */}
				<ModuleSearchField
					name="skll_user_assigned_uid"
					label={t('DETAILS_SKILLS_FIELD_ASSIGNED_USER')}
					module="users"
					uid={props.model.skll_user_assigned_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
